// extracted by mini-css-extract-plugin
export var container = "_6m-0";
export var error = "_6m-9";
export var label = "_6m-5";
export var light = "_6m-6";
export var md = "_6m-3";
export var sm = "_6m-2";
export var thin = "_6m-8";
export var thinBold = "_6m-7";
export var vertical = "_6m-4";
export var xs = "_6m-1";